import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-potencia-kits-modal',
  templateUrl: './potencia-kits-modal.component.html',
  styleUrls: ['./potencia-kits-modal.component.scss']
})
export class PotenciaKitsModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  potencia: Number;

  constructor(public dialogRef: MatDialogRef<PotenciaKitsModalComponent>, private router: Router) { }

  ngOnInit(): void {
  }

  fechar() {
    this.dialogRef.close(this.potencia);
  }
  voltar() {
    this.dialogRef.close();
    this.router.navigate(['dashboard']);
  }
}
